export default "__VITE_ASSET__BU_rWURR__"